import { SxProps, Theme } from '@mui/material';
import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';

export const container: SxProps<Theme> = ((theme: LensTheme) => ({
  display: 'flex',
  gap: theme.tokens.core.spacing[1].value,
})) as SxProps<Theme>;
